import Mandate from '../entities/Mandate';
import MandatesResponseDTO from '../entities/MandatesResponseDTO';

const AuthorizationResponseDTOtoAuthorizationAdapter = (response: MandatesResponseDTO): Mandate[] => {
  if (!response.body) {
    throw Error();
  }

  return response.body.mandateResponseList.map(
    authorization =>
      new Mandate(
        authorization.status,
        authorization.account,
        authorization.userId,
        authorization.postingDate,
        authorization.amount,
        authorization.currency,
        authorization.referenceNumber,
        authorization.beneficiaryName,
        authorization.accountId,
        authorization.orderDirection,
        authorization.globalOrderId,
        authorization.orderMessageType,
        authorization.accountNumber,
        authorization.customerId,
        authorization.orderProcessType,
        authorization.processStatus,
        authorization.eligibleForDealerRate,
        authorization.username,
        authorization.transferType,
      ),
  );
};

export { AuthorizationResponseDTOtoAuthorizationAdapter };
